import React from "react";
import Dropzone from "react-dropzone";

import dropFile from "./assets/drop_file.png";


class FullScreen extends React.Component {
    constructor() {
      super()
      this.state = {
        files: [],
        dropzoneActive: false
      }
    }
  
    onDragEnter() {
      this.setState({
        dropzoneActive: true
      });
    }
  
    onDragLeave() {
      this.setState({
        dropzoneActive: false
      });
    }
  
    onDrop(files) {
      this.setState({
        files,
        dropzoneActive: false
      });

      this.props.onDropFile(files)
    }
  
    applyMimeTypes(event) {
      this.setState({
        accept: event.target.value
      });
    }
  
    render() {
      const { dropzoneActive } = this.state;
      const overlayStyle = {
        position: 'absolute',
        top: -3,
        right: -3,
        bottom: -3,
        left: -3,
          borderRadius:20,
        background: 'rgba(0,0,0,0.5)',
        textAlign: 'center',
        color: '#fff'
      };
      return (
          <div

          style={{
              cursor:"pointer",
              borderColor:"grey",
              borderStyle:"dotted",
              borderRadius:20,
              borderWidth:3,
              position: "relative",
              width:"100%",
              height:"calc(100vh - 100px)"
          }}
          >
        <Dropzone
          multiple={false}
          style={{width:"100%", height:"100%"}}
          accept={"image/*"}
          onDrop={this.onDrop.bind(this)}
          onDragEnter={this.onDragEnter.bind(this)}
          onDragLeave={this.onDragLeave.bind(this)}
        >

            <div className="w-full h-full flex justify-center align-center">
                <div className="align-center self-center text-center opacity-50">
                <img alt="Drop File" className="align-center mx-auto block opacity-50" src={dropFile} width="100" />
                <h3 className="text-center m-4 font-light">Drop your incomplete logo here</h3>
                </div>
            </div>
          { dropzoneActive && <div style={overlayStyle}>Drop files...</div> }
        </Dropzone>
          </div>
      );
    }
  }
  
export default FullScreen;


// WEBPACK FOOTER //
// ./src/FullScreen.js